import { render, staticRenderFns } from "./NicheSingle.vue?vue&type=template&id=2c05e86e&"
import script from "./NicheSingle.vue?vue&type=script&lang=js&"
export * from "./NicheSingle.vue?vue&type=script&lang=js&"
import style0 from "./NicheSingle.vue?vue&type=style&index=0&id=2c05e86e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports